import type { ChatDataTableEmbed, ChatTimeseriesChartEmbed } from "./types";

/** Only explicit deliverable tables start expanded in tool-step detail rows. */
export function isDeliverableDataTableEmbed(embed: ChatDataTableEmbed): boolean {
  return embed.presentation === "deliverable";
}

/** Intermediate analytics embeds stay off the timeline unless explicitly deliverable. */
export function shouldShowStandaloneAnalyticsEmbed(
  embed: ChatDataTableEmbed | ChatTimeseriesChartEmbed,
): boolean {
  return embed.presentation !== "step";
}
